<template>
  <div>

    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <!--begin::Base Table Widget 7-->
        <div class="card card-custom card-stretch gutter-b" id="page">
          <!--begin::Header-->
          <div class="card-header border-0 mt-5">
            <h3 class="card-title align-items-start flex-column text-dark">
              <span class="font-weight-bolder text-dark"
                >Liste des categories</span
              >
            </h3>
            <div class="card-toolbar"></div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-0 mt-n3">
            <!--begin::Table-->

            <DxDataGrid
              @initialized="saveGridInstance"
              :data-source="dataSource"
              :remote-operations="true"
              :columns="columns"
              :show-row-lines="true"
              :word-wrap-enabled="true"
              :show-borders="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="false"
              :hover-state-enabled="true"
              :column-auto-width="true"
              :show-column-lines="true"
              @selection-changed="onSelectionChanged"
            >
              >
              <DxFilterRow :visible="true" />

              <DxHeaderFilter :visible="true" :allow-search="true" />
              <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[5, 10, 20]"
              />
              <DxGroupPanel :visible="true" />
              <DxGrouping :auto-expand-all="true" />
              <DxPaging :page-size="10" />
              <DxSearchPanel :visible="true" />
              <DxSummary>
                <DxTotalItem
                  column="name"
                  summary-type="count"
                  display-format="{0}"
                />
              </DxSummary>
            </DxDataGrid>
            <br />
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Base Table Widget 7-->
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import SearchApiService from "../../../core/services/searchapi.service";
import DxHelper from "../../../helpers/dx.helper";

export default {
  name: "categories-list",
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      pharmacy: {},
      medicinesCount: {
        availableMedicineNbr: 0,
        notAvailableMedicineNbr: 0,
        uponRequestMedicineNbr: 0,
        totalMedicineNbr: 0,
      },
      dataSource: {},
      columns: [
        {
          dataField: "name",
          caption: "Categorie",
          sortIndex: 0,
          sortOrder: "asc",
        }
      ],
      selectedMedicinesIds: [],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Categories", route: "list" },
      { title: "Liste" },
    ]);

    this.dataSource = createStore({
      key: "guid",
      loadUrl: `${SearchApiService.baseURL}Categories`,
      onBeforeSend: DxHelper.onBeforeSend,
      onAjaxError : DxHelper.onAjaxError
    });

  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    onSelectionChanged(e) {
      this.selectedMedicinesIds = e.selectedRowKeys;
    },

  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
